import { ElementDetails } from "@/lib/types";

export const details = {
  name: "Search",
  description: "Search the web",
  category: "Widget",
  grid: {},
  defaultProps: {},
  fields: [],
} satisfies ElementDetails;
